import EmptyTableState from 'components/EmptyTableState';
import ListFooter from 'components/ListFooter';
import LoadingIndicator from 'components/LoadingIndicator';
import { resourceQueryParamName } from 'constants/resourceQueryNames';
import React from 'react';
import LoadingOverlay from 'react-loading-overlay-ts';
import { useSelector } from 'react-redux';

import {
  getNotifications,
  getNotificationsCount,
  getNotificationsLoading,
} from 'selectors/notifications';
import NotificationListRow from './NotificationListRow';

const NotificationsTable: React.FC = () => {
  const notifications = useSelector(getNotifications);
  const loading = useSelector(getNotificationsLoading);
  const isEmpty = notifications.length === 0;

  return (
    <>
      <div className="h-full table-wrapper__new custom-scrollbar overflow-auto">
        <LoadingOverlay
          active={loading}
          spinner={<LoadingIndicator size="10" />}
          fadeSpeed={0}
          styles={{
            content: (base) => ({
              ...base,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }),
            wrapper: (base) => ({
              ...base,
              height: '100%',
            }),
            spinner: () => ({}),
            overlay: (base) => ({
              ...base,
              zIndex: 10,
            }),
          }}
        >
          <table className="h-fit table-wrapper__table table-wrapper_table--fixed">
            <thead className="sticky top-0 z-10">
              <tr>
                <th aria-hidden className="table-wrapper__new-th py-0 w-13" />
                <th className="table-wrapper__new-th table-wrapper__th--w-24">Context</th>
                <th className="table-wrapper__new-th">Message</th>
                <th className="table-wrapper__new-th table-wrapper__th--w-18 leading-3">Date</th>
              </tr>
            </thead>
            <tbody className="table-wrapper__tbody">
              {isEmpty ? (
                <EmptyTableState message="There are no notifications to display" colCount="4" />
              ) : (
                notifications?.map((notification) => (
                  <NotificationListRow notification={notification} key={notification.uuid} />
                ))
              )}
            </tbody>
          </table>
        </LoadingOverlay>
      </div>
      <div className="flex justify-center bg-white">
        <ListFooter
          resourceStateName={resourceQueryParamName.notifications}
          resourceName="notification"
          getResourceList={getNotifications}
          getResourceTotalCount={getNotificationsCount}
          getResourceLoading={getNotificationsLoading}
        />
      </div>
    </>
  );
};

export default NotificationsTable;
